import React from "react";

export default function Spacer({ height = "64px" }) {
  return <div id="spacer" style={{ height: height }}></div>;
}
